var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-trend"},[_vm._m(0),_c('ClassCompare',_vm._b({},'ClassCompare',_vm.$attrs,false))],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"c-trend__header"},[_vm._v("测-学知识点趋势图")]),_c('div',{staticClass:"c-trend__bgc"},[_c('div',{staticClass:"knowledge-trend"})])])
}]

export { render, staticRenderFns }